import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CSVButton from '../Common/CSVButton';

interface SchemeHeaderProps {
  title: string;
  showBack?: boolean;
  onBackClick?: () => void;
  onCreateClick?: () => void;
  onExportCsv?: () => void;
  showActions?: boolean;
}

export const SchemeHeader: React.FC<SchemeHeaderProps> = ({
  title = 'Scheme',
  showBack = true,
  onBackClick,
  onCreateClick: _onCreateClick,
  onExportCsv,
  showActions = true,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 mb-6 select-none">
      {/* Title & Back Arrow */}
      <div className="flex items-center gap-3">
        {showBack && (
          <button
            onClick={handleBack}
            className="w-8 h-8 rounded-full bg-[#C1272D] hover:bg-[#A81E23] transition-all flex items-center justify-center text-white cursor-pointer shadow-sm"
            title="Go Back"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
        )}
        <h1 className="text-2xl font-extrabold text-[#C1272D] tracking-tight">
          {title}
        </h1>
      </div>

      {/* Top Action Buttons */}
      {showActions && (
        <div className="flex items-center gap-3">
          {/* <button
            onClick={onCreateClick || (() => navigate('/scheme/create'))}
            className="bg-[#B71C1C] hover:bg-[#960101] text-white text-xs md:text-sm font-semibold px-4 py-2 rounded-lg flex items-center gap-1.5 shadow-sm transition-all hover:shadow cursor-pointer"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
            </svg>
            Create Scheme
          </button> */}

          {onExportCsv ? (
            <CSVButton onClick={onExportCsv} />
          ) : (
            <CSVButton onClick={() => alert('Exporting schemes to CSV...')} />
          )}
        </div>
      )}
    </div>
  );
};
